export default class ConnectionAdapter {
  static connection() {
    return navigator.connection;
  }

  static hasNetworkInformationObject() {
    return !!this.connection();
  }

  static liteModeEnabled() {
    if (!this.hasNetworkInformationObject()) {
      return false;
    }

    return this.connection().saveData;
  }
}
